module.exports = __webpack_public_path__ + "img/house_ev_off.8b00c978.png";